import { Routes, Route, HashRouter } from 'react-router-dom';

import Header from './components/Header';
import Main from './components/Main';
import Footer from './components/Footer';
import Form from './components/Form';
import Solo from './components/offers/Solo';
import Duo from './components/offers/Duo';
import Online from './components/offers/Online';
import ScrollToTop from './components/ScrollToTop';
import Reviews from './components/Reviews';
import Plan from './components/offers/Plan';
import OfferEditor from './components/admin/OfferEditor';

function App() {
  return (
    // <div className="App">
    //   <Header />
    //   <Main />
    //   <Form />
    //   <Footer />
    // </div>
    <HashRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <div>
              <Main />
              <Form />
              <Reviews />
            </div>
          }
        />
        <Route path="/solo" element={<Solo />} />
        <Route path="/duo" element={<Duo />} />
        <Route path="/online" element={<Online />} />
        <Route path="/plan" element={<Plan />} />
        <Route path="/pb--admin--offer-editor" element={<OfferEditor />} />
      </Routes>
      <Footer />
    </HashRouter>
  );
}

export default App;
